import { render, staticRenderFns } from "./BaseT.vue?vue&type=template&id=e119d1b6"
import script from "./BaseT.vue?vue&type=script&lang=js"
export * from "./BaseT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports